import { Component, OnInit } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
    selector: 'formly-currency-input',
    template:
        `
        <span>{{props?.label + (props?.required ? ' *': ' ')}}</span>
        <div class="input-group" style="margin-top: 8px; margin-bottom: 15px;">
            <div class="input-group-prepend">
                <span class="input-group-text">$</span>
            </div>
            <input [formControl]="formControl" [formlyAttributes]="field" class="form-control" matInputWithComma>
        </div>
    `,
})
export class FormlyCurrencyInputComponent extends FieldType<FieldTypeConfig> implements OnInit {

    ngOnInit() {
        console.log(this.field);
    }

}